import React from "react";
import Router from "./routes";
import "./App.css";

function App() {
  return (
    <div className="App App-header">
      <Router />
    </div>
  );
}

export default App;
